import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface EmailAddressCcProps {
  band: Band
}

export const EmailAddressCc: React.FC<EmailAddressCcProps> = ({ band }) => {
  const fieldData = {
    field: "email_address_cc",
    name: "bandEmailAddressCc",
    label: "CC Email Addresses",
    placeholder: "Comma separated emails to CC on payout and event emails",
    required: false,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
